<div *ngIf="isLoading">
  <i class="pi pi-spin pi-spinner" style="font-size: 3em; color: grey;"></i>
</div>
<p-table #dataTable selectionMode="single" [value]="bookings"
  *ngIf="bookingSearchService.recordNumber && bookingSearchService.recordsByPage" [paginator]="true"
  [loading]="bookingSearchService.loading" [rows]="bookingSearchService.recordsByPage" [totalRecords]="bookings.length"
  paginatorPosition="both" [showLoader]="true">
  <ng-template pTemplate="header">
    <tr>
      <th [style]="{'width':'80px'}" pSortableColumn="id">ID
        <p-sortIcon field="id"></p-sortIcon>
      </th>
      <th id="active-head" pSortableColumn="isActive">Active
        <p-sortIcon field="isActive"></p-sortIcon>
      </th>
      <th pSortableColumn="users">
        Users
        <p-sortIcon field="users"></p-sortIcon>
      </th>
      <th pSortableColumn="studentFirstName">
        First name
        <p-sortIcon field="studentFirstName"></p-sortIcon>
      </th>
      <th pSortableColumn="studentLastName">
        Last name
        <p-sortIcon field="studentLastName"></p-sortIcon>
      </th>
      <th pSortableColumn="school.name">
        School
        <p-sortIcon field="school.name"></p-sortIcon>
      </th>
      <th [style]="{'width':'120px'}" pSortableColumn="courseName">
        Course
        <p-sortIcon field="courseName"></p-sortIcon>
      </th>
      <th [style]="{'width':'120px'}" pSortableColumn="startDate">Start
        <p-sortIcon field="startDate"></p-sortIcon>
      </th>
      <th [style]="{'width':'120px'}" pSortableColumn="endDate">
        End
        <p-sortIcon field="endDate"></p-sortIcon>
      </th>
      <th [style]="{'width':'130px'}" pSortableColumn="language.id">
        Language
        <p-sortIcon field="language.id"></p-sortIcon>
      </th>
      <th [style]="{'width':'130px'}" pSortableColumn="duration">
        Duration
        <p-sortIcon field="duration"></p-sortIcon>
      </th>
      <th [style]="{'width':'120px'}" pSortableColumn="dueAmount">
        Due
        <p-sortIcon field="dueAmount"></p-sortIcon>
      </th>
    </tr>
    <tr>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'id', 'contains')"
          [style]="{'width':'100%'}"> -->
      </th>
      <th>
        <!-- <p-checkbox binary="true" (onChange)="dataTable.filter($event.checked, 'isActive', 'equals')"></p-checkbox> -->
      </th>
      <th>
        <!-- <p-dropdown [style]="{'min-width':'100px'}" placeholder="select" [options]="users"
          (onChange)="dataTable.filter($event.value?.name, 'userNames', 'contains')" optionLabel="name" [filter]="true"
          showClear="true">
          <ng-template let-user pTemplateName="item">
            <span>{{user.name | titlecase}}</span>
          </ng-template>
        </p-dropdown> -->
      </th>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'studentFirstName', 'contains')"
          [style]="{'width':'100%'}"> -->
      </th>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'studentLastName', 'contains')"
          [style]="{'width':'100%'}"> -->
      </th>
      <th>
        <!-- <p-dropdown [style]="{'min-width':'100%'}" placeholder="select" [options]="schools"
          (onChange)="dataTable.filter($event.value?.id, 'school.id', 'equals')" optionLabel="name" [filter]="true"
          showClear="true">
          <ng-template let-school pTemplateName="item">
            <span>{{school.name | titlecase}}</span>
          </ng-template>
        </p-dropdown> -->
      </th>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'courseName', 'contains')"
          [style]="{'width':'100%'}"> -->
      </th>
      <th>
        <p-calendar appendTo="body" (onSelect)="onDateSelect($event, 'startDate')"
          (onClearClick)="dataTable.filter('', 'startDate', 'equals')" [showButtonBar]="true" [readonlyInput]="true"
          dateFormat="dd/mm/yy" [inputStyle]="{'width':'100%'}"></p-calendar>
      </th>
      <th>
        <p-calendar appendTo="body" (onSelect)="onDateSelect($event, 'endDate')"
          (onClearClick)="dataTable.filter('', 'endDate', 'equals')" [showButtonBar]="true" [readonlyInput]="true"
          dateFormat="dd/mm/yy" [inputStyle]="{'width':'100%'}"></p-calendar>
      </th>
      <th>
        <!-- <p-dropdown [style]="{'min-width':'100%'}" placeholder="select" [options]="languages"
          (onChange)="dataTable.filter($event.value?.id, 'language.id', 'equals')" optionLabel="name" showClear="true"> -->
          <!-- <ng-template let-language pTemplateName="item">
            <span>{{language.name | titlecase}}</span>
          </ng-template>
        </p-dropdown> -->
      </th>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'duration', 'contains')"
          [style]="{'width':'100%'}"> -->
      </th>
      <th>
        <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'dueAmount', 'contains')"
          [style]="{'width':'100%'}"> -->
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-booking>
    <tr [pSelectableRow]="booking">
      <td id="id">
        <a (click)="openBooking(booking)">
          {{booking.id}}
        </a>
      </td>
      <td id="active">
        <span *ngIf="booking.isActive">
          X
        </span>
      </td>
      <td>
        <span *ngFor="let user of booking.users">
          {{user.name}}
        </span>
      </td>
      <td id="first-name">
        <a (click)="openBooking(booking)">
          {{booking.studentFirstName | titlecase}}
        </a>
      </td>
      <td id="last-name">
        <a (click)="openBooking(booking)">
          {{booking.studentLastName | titlecase}}
        </a>
      </td>
      <td>
        {{booking.school.name}}
      </td>
      <td>
        {{booking.courseName}}
      </td>
      <td id="start">
        {{booking.startDate | dateFormat: "DD/MM/YYYY"}}
      </td>
      <td id="end">
        {{booking.endDate | dateFormat: "DD/MM/YYYY"}}
      </td>
      <td>
        {{booking.language.name | titlecase}}
      </td>
      <td>
        {{booking.duration}}
      </td>
      <td>
        {{booking.dueAmount}}
      </td>
    </tr>
  </ng-template>
</p-table>